"use client";

import Image, { type StaticImageData } from "next/image";
import { motion } from "framer-motion";

type FieldPreviewSectionProps = {
  title: string;
  leftImage: StaticImageData;
  rightImage: StaticImageData;
  leftAlt: string;
  rightAlt: string;
};

export default function FieldPreviewSection({
  title,
  leftImage,
  rightImage,
  leftAlt,
  rightAlt,
}: FieldPreviewSectionProps): JSX.Element {
  return (
    <section className="bg-white py-12">
      <div className="mx-auto max-w-[90rem] px-6 md:px-8">
        <motion.h2
          initial={false}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.4 }}
          className="mb-3 font-space-age text-base tracking-[0.2em] text-black/90"
        >
          {title}
        </motion.h2>
        <div className="grid gap-4 md:grid-cols-2">
          <motion.div
            initial={false}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.4 }}
            whileHover={{ scale: 1.015 }}
            className="overflow-hidden rounded-2xl"
          >
            <Image
              src={leftImage}
              alt={leftAlt}
              className="aspect-[16/9] w-full object-cover"
            />
          </motion.div>
          <motion.div
            initial={false}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.4, delay: 0.05 }}
            whileHover={{ scale: 1.015 }}
            className="overflow-hidden rounded-2xl"
          >
            <Image
              src={rightImage}
              alt={rightAlt}
              className="aspect-[16/9] w-full object-cover"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
